











































import Vue from 'vue';
import Component from 'vue-class-component';
import FormTemplate from '@/views/formular/FormTemplate.vue';
import {HTTP_SERVICE_INSTANCE} from '@/services/http.service';
import AmetrasSearchField from '@/fields/text/AmetrasSearchField.vue';
import {DisguiseBusinessExceptionWrapper} from '@/exception/disguise-business-exception-wrapper';
import {
  MY_COMPANY_CHANGED_LISTENER_SERVICE_INSTANCE
} from '@/views/pageskeleton/companychange/company-changed-listener.service';

@Component({
  components: {
    FormTemplate,
    AmetrasSearchField
  }
})
export default class CompanyChangeTemplate extends Vue {
  input: DisguiseDto.FTDefinitionDto = {};
  loading: boolean = false;
  initLoading: boolean = false;

  created() {
    this.loadMyCompanyDetails();

    MY_COMPANY_CHANGED_LISTENER_SERVICE_INSTANCE.registerListener(() => {
      this.loadMyCompanyDetails();
    });
  }

  showCompanyChangeSearch() {
    if (!this.$store.state.companyChange.show) {
      this.$store.commit('showCompanyChangeSearch');
    }
  }

  private loadMyCompanyDetails() {
    this.initLoading = true;
    HTTP_SERVICE_INSTANCE.getAxios()
        .get<DisguiseDto.FTDefinitionDto>('/identity/v0/form/mycompanychange')
        .then((response) => {
          this.input = response.data;
          this.initLoading = false;
        }, (error) => {
          if (!(error instanceof DisguiseBusinessExceptionWrapper)) {
            this.$store.commit('showSnack', {
              message: 'Firmenfeld konnte nicht geladen werden.',
              color: 'error'
            });
          }
          this.initLoading = false;
        });
  }
}
